if (!customElements.get('gift-with-purchase')) {
  class GiftWithPurchase extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.animateProgress();
      this.reconcile();
    }

    animateProgress() {
      const progressLine = this.querySelector('[data-progress-line]');
      if (!progressLine) return;
      setTimeout(() => {
        progressLine.style.width = this.dataset.progress;
      }, 100);
    }

    get itemsElement() {
      if (this.closest('cart-drawer')) {
        return document.querySelector('cart-drawer-items');
      }
      return this.closest('cart-items');
    }

    getSections() {
      return this.itemsElement?.getSectionsToRender() || [];
    }

    onClick(event) {
      const addButton = event.target.closest('[data-gift-add]');
      if (addButton && !addButton.disabled) {
        event.preventDefault();
        this.selectGift(addButton);
        return;
      }
      const removeButton = event.target.closest('[data-gift-remove]');
      if (removeButton && !removeButton.disabled) {
        event.preventDefault();
        this.removeGift(removeButton);
      }
    }

    async reconcile() {
      // "key:qty," pairs; line keys themselves contain a colon, so split on the last one
      const adjustments = (this.dataset.adjustments || '')
        .split(',')
        .filter(Boolean)
        .map(pair => {
          const separator = pair.lastIndexOf(':');
          return {
            key: pair.slice(0, separator),
            quantity: Number(pair.slice(separator + 1))
          };
        });
      if (!adjustments.length) return;

      this.toggleLoading(true);
      try {
        for (const { key, quantity } of adjustments) {
          await this.changeLine(key, quantity);
        }
        await this.refreshSections();
      } finally {
        this.toggleLoading(false);
      }
    }

    async selectGift(button) {
      button.disabled = true;
      this.toggleLoading(true);
      try {
        const body = JSON.stringify({
          items: [
            {
              id: Number(button.dataset.variantId),
              quantity: 1,
              properties: { _gift: '1' }
            }
          ],
          sections: this.getSections().map(section => section.section),
          sections_url: window.location.pathname
        });

        const response = await fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body }
        });
        const parsedState = await response.json();

        if (parsedState.status) {
          console.error(parsedState.description);
          button.disabled = false;
          return;
        }

        this.renderSections(parsedState);
      } finally {
        this.toggleLoading(false);
      }
    }

    async removeGift(button) {
      button.disabled = true;
      this.toggleLoading(true);
      try {
        const newQuantity = Number(button.dataset.newQuantity || 0);
        await this.changeLine(button.dataset.lineKey, newQuantity);
        await this.refreshSections();
      } finally {
        this.toggleLoading(false);
      }
    }

    async changeLine(key, quantity) {
      const body = JSON.stringify({ id: key, quantity });
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body }
      });
      return response.json();
    }

    async refreshSections() {
      const sections = this.getSections().map(section => section.section);
      if (!sections.length) return;
      const response = await fetch(
        `${window.location.pathname}?sections=${sections.join(',')}`
      );
      const parsedSections = await response.json();
      this.renderSections({ sections: parsedSections });
    }

    renderSections(parsedState) {
      if (!parsedState.sections) return;
      this.getSections().forEach(section => {
        const element =
          document.querySelector(section.selector) ||
          document.querySelector(section.id);
        if (!element) return;
        const newElement = new DOMParser()
          .parseFromString(
            parsedState.sections[section.section],
            'text/html'
          )
          .querySelector(section.selector);
        if (newElement) element.innerHTML = newElement.innerHTML;
      });
      if (typeof updateFreeShipping === 'function') updateFreeShipping();
    }

    toggleLoading(state) {
      this.itemsElement?.classList.toggle('is-loading', state);
    }
  }

  customElements.define('gift-with-purchase', GiftWithPurchase);
}
